
import Header from "./index";

export default class HeaderView extends Header {}
